import { render } from "./EditWOCategory.vue?vue&type=template&id=d33e4938&scoped=true"
import script from "./EditWOCategory.vue?vue&type=script&lang=js"
export * from "./EditWOCategory.vue?vue&type=script&lang=js"

import "./EditWOCategory.vue?vue&type=style&index=0&id=d33e4938&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d33e4938"]])

export default __exports__